export default __webpack_public_path__ + "static/media/cons.9ff9afda.svg";